module.exports = __webpack_public_path__ + "static/costs-icn-7dbd03f53105648f36ebae74c7dfd5ee.svg";